(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const group = root.querySelector('[data-bella-group]');
    const pattern = root.querySelector('[data-bella-pattern]');
    const selectors = [...root.querySelectorAll('[data-bella-option]')];
    const id = root.querySelector('[data-bella-variant]');
    const button = root.querySelector('[data-bella-submit]');
    const status = root.querySelector('[data-bella-status]');
    let request = 0;
    let controller;
    let purchasing = false;
    selectors.filter(s => s.hasAttribute('data-bella-length')).forEach(s => {
      [...s.options].sort((a,b) => Number(a.dataset.name) - Number(b.dataset.name)).forEach(o => s.append(o));
    });
    if (!pattern) { status.textContent = 'Texture choices could not be loaded.'; return; }
    group.value = pattern.selectedOptions[0].dataset.group;
    function filter() {
      [...pattern.options].forEach(o => { o.hidden = o.dataset.group !== group.value; o.disabled = o.hidden; });
      if (pattern.selectedOptions[0].disabled) pattern.value = [...pattern.options].find(o => !o.disabled).value;
      root.querySelector('[data-bella-pattern-property]').value = pattern.selectedOptions[0].dataset.name;
    }
    function show(v, valid) {
      id.value = valid && v.id ? v.id : '';
      button.disabled = !valid || !v.available;
      status.classList.toggle('bella-selection-error', !valid || !v.available);
      status.textContent = !valid ? 'This size, pattern and length combination is not offered. Please choose another option.' : !v.available ? 'This combination is currently unavailable.' : '';
      const scope = root.closest('[data-section-id]') || document;
      const price = scope.querySelector('[data-product-price]');
      if (valid && price) price.textContent = v.price;
      const compare = scope.querySelector('[data-compare-price]');
      if (compare) compare.textContent = '';
    }
    async function update() {
      filter();
      controller?.abort();
      controller = new AbortController();
      const seq = ++request;
      button.disabled = true;
      id.value = '';
      status.textContent = 'Checking your selection…';
      status.classList.remove('bella-selection-error');
      const url = new URL(root.dataset.url, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('section_id', root.dataset.section);
      url.searchParams.set('option_values', selectors.map(s => s.value).join(','));
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Selection lookup failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = doc.querySelector('[data-bella-selected]');
        if (!data) throw new Error('Selection data missing');
        const v = JSON.parse(data.textContent);
        if (seq !== request) return;
        show(v, !!v.selected);
      } catch (e) {
        if (e.name === 'AbortError' || seq !== request) return;
        status.textContent = 'Unable to check this selection. Please change an option to try again.';
        status.classList.add('bella-selection-error');
      }
    }
    group.addEventListener('change', update);
    selectors.forEach(s => s.addEventListener('change', update));
    form.addEventListener('submit', async e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (button.disabled || !id.value || purchasing || !form.reportValidity()) return;
      purchasing = true;
      button.disabled = true;
      status.textContent = 'Adding to your cart…';
      status.classList.remove('bella-selection-error');
      try {
        const endpoint = new URL(form.action, location.origin);
        endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
        const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: {Accept:'application/json'} });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this selection.');
        const cart = new URL(form.action, location.origin);
        cart.pathname = cart.pathname.replace(/\/add\/?$/, '');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) cart.searchParams.set('preview_theme_id', preview);
        location.assign(cart);
      } catch (e) {
        status.textContent = e.message;
        status.classList.add('bella-selection-error');
        purchasing = false;
        button.disabled = false;
      }
    }, true);
    update();
  }
  const start = () => document.querySelectorAll('[data-bella-textures]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
